import { isPhoneDevice } from '@/libs/funtions';
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

let routerArr = [];

if (isPhoneDevice()) {
  routerArr = [
    {
      path: '/',
      name: 'index',
      component: () => import('../mobView/index/index.vue')
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: () => import('../mobView/introduction/index.vue')
    }
  ]
} else {
  routerArr = [
    {
      path: '/',
      name: 'index',
      component: () => import('../views/index/index.vue')
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: () => import('../views/introduction/index.vue')
    }
  ]
}

const routes: Array<RouteConfig> = routerArr;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
